module.exports = __webpack_public_path__ + "img/2025-03-12c_3.e96a8fcc.jpg";